const COLORS = {
  violeta50:  "#F0EBFF",
  violeta100: "#D4BFFF",
  violeta200: "#B899FF",
  violeta400: "#8D54FF",
  violeta600: "#6A2FE0",
  violeta700: "#5A1FAF",
  violeta800: "#4A1BAA",
  violeta900: "#2C0C6B",

  verde50:    "#EDFADF",
  verde100:   "#C6EDA0",
  verde200:   "#9FDD65",
  verde400:   "#7FD858",
  verde600:   "#52A832",
  verde800:   "#347518",

  azul50:     "#E4F4FF",
  azul100:    "#A8DCFF",
  azul200:    "#6CC8FF",
  azul400:    "#37B7FF",
  azul600:    "#1488CC",
  azul800:    "#0A5A94",

  neutro50:   "#F7F6F3",
  neutro100:  "#E8E7E2",
  neutro400:  "#C4C3BC",
  neutro500:  "#888784",
  neutro700:  "#525150",
  neutro900:  "#2E2D2C",

  rojo50:     "#FFF0F0",
  rojo400:    "#E24B4A",
  rojo600:    "#A32D2D",

  ambar50:    "#FFF8E1",
  ambar400:   "#EDA100",
  ambar600:   "#B37800",
};

export default COLORS;